import { render, staticRenderFns } from "./Sportach.vue?vue&type=template&id=81fe9ce4&"
import script from "./Sportach.vue?vue&type=script&lang=js&"
export * from "./Sportach.vue?vue&type=script&lang=js&"
import style0 from "./Sportach.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VOverlay,VProgressCircular})
